module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Booking Approval Logs Dashboard")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Created Date Range :")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.SearchFilter
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusVal",
      "option-text": "statusText",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "branchfilter"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "commonFilter"
    }
  }, [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Booking No, Client, Line, Agent, User..."
    },
    on: {
      "input": _vm.SearchFilter
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px 1rem 0 5rem"
    },
    attrs: {
      "cols": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.logsList,
      "responsive": "",
      "fields": _vm.Columns,
      "primary-key": "cbal_id",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "cbal_id",
      fn: function(row) {
        return [_c('span', [_vm._v("\n              " + _vm._s(row.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n            ")])]
      }
    }, {
      key: "BookingNo",
      fn: function(row) {
        return [_c('div', {
          staticStyle: {
            "font-weight": "bold",
            "color": "#36304a"
          }
        }, [_vm._v("\n              " + _vm._s(row.item.BookingNo || 'N/A') + "\n            ")])]
      }
    }, {
      key: "booking_info",
      fn: function(row) {
        return [_c('div', [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Type:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.BookingType || 'N/A'))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("For:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.BookingFor || 'N/A'))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Contract:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.ContractNo || 'N/A'))])])]
      }
    }, {
      key: "client_sline_agent",
      fn: function(row) {
        return [_c('div', [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Client:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.ClientName || 'N/A'))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Line:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.SlineName || 'N/A'))]), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Agent:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.AgentName || 'N/A'))])])]
      }
    }, {
      key: "Reason",
      fn: function(row) {
        return [_c('div', {
          staticStyle: {
            "max-width": "200px",
            "white-space": "normal"
          }
        }, [_vm._v("\n              " + _vm._s(row.item.Reason || 'N/A') + "\n            ")])]
      }
    }, {
      key: "Remark",
      fn: function(row) {
        return [_c('div', {
          staticStyle: {
            "max-width": "250px",
            "white-space": "normal"
          }
        }, [_vm._v("\n              " + _vm._s(row.item.Remark || 'N/A') + "\n            ")])]
      }
    }, {
      key: "Status",
      fn: function(row) {
        return [(row.item.Status === 'Approved') ? _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Approved")]) : (row.item.Status === 'Rejected') ? _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Rejected")]) : _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(_vm._s(row.item.Status || 'Pending'))])]
      }
    }, {
      key: "user_logs",
      fn: function(row) {
        return [_c('div', [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Created By:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.CreatedBy || 'N/A'))]), _vm._v(" "), (row.item.CreatedAt) ? _c('span', {
          directives: [{
            name: "slot",
            rawName: "v-slot:default",
            arg: "default"
          }],
          staticClass: "text-muted small"
        }, [_c('br'), _vm._v("at " + _vm._s(row.item.CreatedAt))]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Approved By:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.item.ApprovedBy || 'N/A'))]), _vm._v(" "), (row.item.ApprovalDate) ? _c('span', {
          directives: [{
            name: "slot",
            rawName: "v-slot:default",
            arg: "default"
          }],
          staticClass: "text-muted small"
        }, [_c('br'), _vm._v("at " + _vm._s(row.item.ApprovalDate))]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f66b0d0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/consoleBooking/bookingApprovalLogs.vue
// module id = 2439
// module chunks = 0